import { Button, Dialog, DialogActions, DialogContent, TextFormInput } from '@yunex/yds-react';
import React, { useState } from 'react';
import { CMP_ADD_VIEW_DIALOG as CMP, CMP_SAVED_VIEWS_FILTER as CMP_PARENT, } from '../../componentNames';
var AddViewDialog = function (_a) {
    var addButtonLabel = _a.addButtonLabel, cancelButtonLabel = _a.cancelButtonLabel, handleAdd = _a.handleAdd, handleClose = _a.handleClose, inputErrorMessage = _a.inputErrorMessage, inputLabel = _a.inputLabel, inputPlaceholder = _a.inputPlaceholder, open = _a.open;
    var _b = useState(''), name = _b[0], setName = _b[1];
    var handleChange = function (e) {
        setName(e.target.value);
    };
    var _c = useState(false), error = _c[0], setError = _c[1];
    var handleSubmit = function () {
        if (name.length > 0) {
            handleAdd(name);
            setError(false);
            handleClose();
            setName('');
        }
        else {
            setError(true);
        }
    };
    var handleCloseCb = function () {
        setError(false);
        handleClose();
        setName('');
    };
    return (React.createElement(Dialog, { "aria-labelledby": "dialog-title", onClose: handleCloseCb, open: open },
        React.createElement(DialogContent, null,
            React.createElement(TextFormInput, { autoFocus: true, error: error, errorMessage: error ? inputErrorMessage : undefined, inputProps: {
                    'data-testid': "".concat(CMP_PARENT, "-").concat(CMP, "-name-field"),
                }, label: inputLabel, onChange: handleChange, onKeyPress: function (e) { return (e.key === 'Enter' ? handleSubmit() : null); }, placeholder: inputPlaceholder, required: true, value: name })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: "primary", "data-testid": "".concat(CMP_PARENT, "-").concat(CMP, "-submit-button"), onClick: handleSubmit }, addButtonLabel),
            React.createElement(Button, { color: "secondary", "data-testid": "".concat(CMP_PARENT, "-").concat(CMP, "-cancel-button"), onClick: handleCloseCb }, cancelButtonLabel))));
};
AddViewDialog.displayName = CMP;
export default AddViewDialog;
//# sourceMappingURL=AddViewDialog.js.map